import { Divider, Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import { SettingRow } from './SettingRow';
import type { SettingItemKey, SettingSectionData } from '../constants';

type Props = {
  section: SettingSectionData;
  personalizationDescription: string;
  showTopDivider: boolean;
  onPressItem: (key: SettingItemKey) => void;
};

export const SettingSection = ({
  section,
  personalizationDescription,
  showTopDivider,
  onPressItem,
}: Props) => {
  const { width } = useScreenSize();

  return (
    <Flex width={width}>
      {showTopDivider && <Divider size="medium" />}
      <Flex padding={{ top: 24, bottom: 8, horizontal: 16 }}>
        <Typography type="subtitle2" color="content_tertiary">
          {section.title}
        </Typography>
      </Flex>
      {section.items.map(item => (
        <SettingRow
          key={item.key}
          title={item.title}
          description={
            item.key === 'personalization'
              ? personalizationDescription
              : undefined
          }
          showRightArrow={item.key !== 'logout'}
          onPress={() => onPressItem(item.key)}
        />
      ))}
    </Flex>
  );
};
